module.exports = __webpack_public_path__ + "static/media/07_tn.9755f60a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/07_tn.jpg
// module id = 316
// module chunks = 0